const AUTH_BACKGROUND_COUNTRIES = [
  'ar',
  'at',
  'be',
  'br',
  'ca',
  'cn',
  'cz',
  'de',
  'es',
  'fr',
  'gb',
  'hu',
  'ie',
  'in',
  'it',
  'jp',
  'lt',
  'nl',
  'pl',
  'ru',
  'tr',
  'ua',
  'us',
  'xx',
] as const;

type AuthBackgroundCountry = (typeof AUTH_BACKGROUND_COUNTRIES)[number];

export const getAuthBackgroundCountry = (
  country?: string,
): AuthBackgroundCountry => {
  const normalizedCountry = country?.toLowerCase();

  return AUTH_BACKGROUND_COUNTRIES.includes(
    normalizedCountry as AuthBackgroundCountry,
  )
    ? (normalizedCountry as AuthBackgroundCountry)
    : 'de';
};
